import React from 'react';

import NowHiringImg from './i/now-hiring.jpg';
import NowHiringImgFr from './i/now-hiring-fr.jpg';
import NowHiringImgMobile  from './i/now-hiring-mobile.jpg';
import NowHiringImgMobileFr from './i/now-hiring-mobile-fr.jpg';

import './style.scss';


const NowHiring = (props) => (
    <div className="now-hiring">
        {props.isDesktop ? 
            <a className="now-hiring-link" href={props.lang !== 'fr' ? 'https://workwithus.aw.ca/' : 'https://workwithus.aw.ca/jobs-fr'} target="_blank" rel="noreferrer noopener"><img src={props.lang !== 'fr' ? NowHiringImg : NowHiringImgFr} alt={props.lang !== 'fr' ? 'Work with us' : 'Travailler avec nous'} height="381" width="97" className="now-hiring-desktop" /></a>    
        :
            <a className="now-hiring-mobile" href={props.lang !== 'fr' ? 'https://workwithus.aw.ca/' : 'https://workwithus.aw.ca/jobs-fr'}  target="_blank" rel="noreferrer noopener"><img src={props.lang !== 'fr' ? NowHiringImgMobile : NowHiringImgMobileFr} alt={props.lang !== 'fr' ? 'Work with us' : 'Travailler avec nous'} height="165" width="695" className="now-hiring-mobile-img" /></a>
        }
    </div>
)

export default NowHiring;